module.exports = __webpack_public_path__ + "static/img/loading-bars.bb765cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loading-bars.svg
// module id = DzIN
// module chunks = 34